<template>
  <Modal
    v-model="visible"
    title="证书查询"
    footer-hide>
    <i-input
      v-model="search.content"
      :placeholder="placeholder"
      clearable
      @on-change="handleContentChange">
      <Select
        slot="prepend"
        v-model="search.mode"
        @on-change="handleModeChange"
        style="width: 80px">
        <Option
          v-for="option in MODE_OPTIONS"
          :key="option.value"
          :value="option.value">
          {{ option.label }}
        </Option>
      </Select>
    </i-input>
    <div class="text-right margin-top-10px">
      <Button
        icon="md-search"
        type="primary"
        :loading="loading"
        @click="handleSearch">
        查询证书
      </Button>
    </div>

    <ul v-if="diplomas.length">
      <li
        class="diploma-item box-shadow margin-top-10px"
        v-for="diploma in diplomas"
        :key="diploma.diplomaId">
        <p>
          <span>证书资质：</span>
          {{ diploma.certName }}
        </p>
        <p :class="{ 'text-theme': search.content === diploma.certSeriesNo }">
          <span>证书编号：</span>
          {{ diploma.certSeriesNo }}
        </p>
        <p>
          <span>持证人：</span>
          {{ diploma.realName }} - {{ diploma.sex | formatSex }}
        </p>
        <p :class="{ 'text-theme': search.content === diploma.idCardSeriesNo }">
          <span>身份证号：</span>
          {{ diploma.idCardSeriesNo | formatIdSeriesNo }}
        </p>
      </li>
    </ul>
  </Modal>
</template>

<script>
import { mapActions } from 'vuex'
import { ID_CARD_REG } from '../../libs/validator'

export default {
  name: 'searchDiploma',
  data () {
    return {
      search: {
        mode: 1,
        content: ''
      },
      diplomas: [],
      loading: false,
      MODE_OPTIONS: [
        { label: '证书编号', value: 1 },
        { label: '身份证号', value: 2 }
      ]
    }
  },
  computed: {
    placeholder () {
      if (this.search.mode === 1) return '请输入证书编号'
      else return '请输入身份证号'
    }
  },
  handlers: {
    handleModeChange () {
      this.search.content = ''
      this.diplomas = []
    },
    handleContentChange () {
      this.diplomas = []
    },
    async handleSearch () {
      const { mode, content } = this.search
      if (!content) {
        window.toast.warning(this.placeholder)
        return
      }
      if (mode === 2 && !ID_CARD_REG.test(content)) {
        window.toast.error('身份证号格式不正确')
        return
      }
      try {
        this.loading = true
        this.diplomas = await this.searchDiploma({ mode, content })
        if (!this.diplomas.length) {
          window.toast.info('未查询到相关证书信息')
          return
        }
      } catch (err) {
        //
      } finally {
        this.loading = false
      }
    }
  },
  methods: {
    ...mapActions([ 'searchDiploma' ])
  }
}
</script>

<style lang="less" scoped>
.diploma-item {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 15px 15px 0;

  p {
    display: flex;
    flex: none;
    width: 45%;
    margin-bottom: 15px;
    
    span {
      flex: none;
      width: 5em;
      font-weight: bold;
    }
  }
}
</style>
